import { render, staticRenderFns } from "./defaultView.vue?vue&type=template&id=cf991e88&scoped=true"
import script from "./defaultView.vue?vue&type=script&lang=js"
export * from "./defaultView.vue?vue&type=script&lang=js"
import style0 from "./defaultView.vue?vue&type=style&index=0&id=cf991e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf991e88",
  null
  
)

export default component.exports